"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

var _GuestRating = _interopRequireDefault(require("../GuestRating"));

var _HotelRating = _interopRequireDefault(require("../HotelRating"));

var _LinkButton = _interopRequireDefault(require("../../../navigation/LinkButton"));

var _Body = _interopRequireDefault(require("../../../text/Body"));

var _AmenitiesList = _interopRequireDefault(require("../AmenitiesList"));

var _HotelContext = _interopRequireDefault(require("../../../../context/HotelContext"));

var _PartnerContext = _interopRequireDefault(require("../../../../context/PartnerContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Container = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "k0xlrg-0"
})(["flex-direction:row;width:100%;"]);
var HotelContentWrapper = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "k0xlrg-1"
})(["margin-left:12px;", "{margin-left:0px;}"], (0, _themeGet.themeGet)('mediaQueries.xl'));
var DetailsLink = (0, _styledComponents["default"])(_LinkButton["default"]).withConfig({
  componentId: "k0xlrg-2"
})(["margin-bottom:", "px;"], (0, _themeGet.themeGet)('space.3'));
var StyledName = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  componentId: "k0xlrg-3"
})(["font-size:", "px;margin-bottom:", "px;margin-top:", "px;font-weight:bold;", "{font-size:", "px;}"], (0, _themeGet.themeGet)('fontSizes.3'), (0, _themeGet.themeGet)('space.1'), (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('mediaQueries.lg'), (0, _themeGet.themeGet)('fontSizes.3'));
var StyledHotelRating = (0, _styledComponents["default"])(_HotelRating["default"]).withConfig({
  componentId: "k0xlrg-4"
})(["margin-bottom:8px;"]);
var DiamondImage = (0, _styledComponents["default"])(_pclnDesignSystem.Image).withConfig({
  componentId: "k0xlrg-5"
})(["margin-bottom:5px;margin-top:-9px;"]);
var HotelImage = (0, _styledComponents["default"])(_pclnDesignSystem.Image).withConfig({
  componentId: "k0xlrg-6"
})(["display:none;", "{display:block;width:212px;height:181px;margin-right:", "px;}"], (0, _themeGet.themeGet)('mediaQueries.xl'), (0, _themeGet.themeGet)('space.3'));
var DesktopFlex = (0, _styledComponents["default"])('div').withConfig({
  componentId: "k0xlrg-7"
})(["display:none;", "{display:block;}"], (0, _themeGet.themeGet)('mediaQueries.lg'));
var MobileFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "k0xlrg-8"
})(["display:block;", "{display:none;}"], (0, _themeGet.themeGet)('mediaQueries.lg'));
var GuestRatingContainer = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "k0xlrg-9"
})(["& >:first-child{margin-right:", "px;}"], (0, _themeGet.themeGet)('space.3'));
var HotelInfo = (0, _react.memo)(function (_ref) {
  var className = _ref.className;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      moreDetails = _useState2[0],
      onMoreDetailsClick = _useState2[1];

  var _useContext = (0, _react.useContext)(_HotelContext["default"]),
      name = _useContext.name,
      address = _useContext.address,
      thumbnail = _useContext.thumbnail,
      hotelRating = _useContext.hotelRating,
      hotelRatingImage = _useContext.hotelRatingImage,
      amenities = _useContext.amenities,
      guestScore = _useContext.guestScore;

  var _useContext2 = (0, _react.useContext)(_PartnerContext["default"]),
      aaaMemberRating = _useContext2.aaaMemberRating;

  return _react["default"].createElement(Container, {
    className: className
  }, _react["default"].createElement(HotelImage, {
    alt: "HotelImage",
    src: thumbnail
  }), _react["default"].createElement(HotelContentWrapper, {
    flexDirection: "column"
  }, _react["default"].createElement(StyledName, null, name), _react["default"].createElement(_Body["default"], {
    bold: true,
    subdued: true,
    mb: 2
  }, address), _react["default"].createElement(_Body["default"], null, hotelRatingImage ? _react["default"].createElement(DiamondImage, {
    alt: "DiamondRating",
    src: hotelRatingImage.props.src
  }) : _react["default"].createElement(StyledHotelRating, {
    useStars: true,
    rating: hotelRating,
    ratingMax: 5
  })), _react["default"].createElement(DesktopFlex, null, renderAmenitiesAndRatings(amenities, aaaMemberRating, guestScore)), _react["default"].createElement(MobileFlex, null, moreDetails ? renderAmenitiesAndRatings(amenities, aaaMemberRating, guestScore) : _react["default"].createElement(DetailsLink, {
    onClick: function onClick() {
      return onMoreDetailsClick(!moreDetails);
    }
  }, "More hotel details"))));
});

var renderAmenitiesAndRatings = function renderAmenitiesAndRatings(amenities, aaaMemberRating, guestScore) {
  return _react["default"].createElement(_pclnDesignSystem.Flex, {
    flexDirection: "column"
  }, _react["default"].createElement(_AmenitiesList["default"], {
    amenities: amenities
  }), _react["default"].createElement(GuestRatingContainer, {
    mt: 2,
    mb: 3
  }, aaaMemberRating && _react["default"].createElement(_GuestRating["default"], {
    titleSmall: true,
    title: "AAA Member",
    rating: Number(aaaMemberRating.toFixed(1)),
    ratingMax: 5,
    useStars: true
  }), guestScore && _react["default"].createElement(_GuestRating["default"], {
    titleSmall: true,
    title: "Additional Reviews",
    rating: Number(guestScore.toFixed(1)),
    ratingMax: 10
  })));
};

HotelInfo.displayName = 'HotelInfo';
HotelInfo.propTypes = {
  className: _propTypes["default"].string
};
HotelInfo.defaultProps = {
  className: ''
};
var _default = HotelInfo;
exports["default"] = _default;